import React from "react";
import { ChartType } from "./models/types";

type IconButtonProps = {
  id: ChartType;
  className: string;
  tooltip: string;

  onClick: (e: any) => void;

  children: JSX.Element;
};

const IconButton = (props: IconButtonProps) => {
  return (
    <div
      id={`${props.id}-chart`}
      onClick={e => props.onClick(e)}
      className={props.className}
      data-tooltip={props.tooltip}
    >
      {props.children}
    </div>
  );
};

export default IconButton;
